module.exports = __webpack_public_path__ + "img/server-3.f66113c.png";